<template>
    <Datepicker
        :format="dateFormat"
        v-model="model"
        :clearable="false"
        :month-picker="props.monthPicker"
        auto-apply
        :utc="true"
        :class="{'is-invalid': !!error}"
        :enable-time-picker="false"
        :input-class-name="!!error ? 'form-control is-invalid' : 'form-control'"
        :ui="{input: !!error ? 'form-control is-invalid' : 'form-control'}">
    </Datepicker>
    <span
        class="invalid-feedback"
        role="alert"
        v-if="error">
        {{ error }}
    </span>
</template>
<script setup lang="ts">
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import {computed, onMounted, ref, toRef} from "vue";

const dateFormat = computed(() => {
    return props.monthPicker ? "MM-yyyy" : "yyyy-MM-dd";
});

const model = defineModel();
defineOptions({
    inheritAttrs: false,
});
const props = defineProps({
    error: {
        type: String,
        default: null,
    },
    monthPicker: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});
</script>
